import classNames from 'classnames';
import React, { FC } from 'react';
import ReactModal from 'react-modal';
import styles from './modal_confirmation_container.module.scss';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  className?: string;
  overlayClassName?: string;
  shouldCloseOnOverlayClick?: boolean;
};

export const ModalConfirmationContainer: FC<Props> = ({
  isOpen,
  onRequestClose,
  className = '',
  overlayClassName = '',
  children,
  shouldCloseOnOverlayClick = true,
}) => {
  const customProps = {
    className: classNames(className, 'react-modal', styles.container),
    overlayClassName: classNames(
      overlayClassName,
      'react-modal__overlay',
      styles.overlay,
    ),
    isOpen,
    ariaHideApp: false,
    shouldCloseOnOverlayClick,
    onRequestClose,
  };

  return <ReactModal {...customProps}>{children}</ReactModal>;
};
